import React from 'react';

const EducationPage = () => {
  return (
    <div>
      <h1>Education</h1>
    </div>
  );
};

export default EducationPage;
